import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles
} from "@webs/components-library/theming";
import {ifDefined} from 'lit/directives/if-defined.js';
import {repeat} from 'lit/directives/repeat.js';


@customElement('webs-content-text-specs')
export class ContentTextSpecs extends LitElement {
  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    moduleSpacingStyles,
    css`

      .m-content-text-specs__first--title {
        color: var(--color-dark-grey);
        margin-bottom: 0;
      }

      .rich-text-container::slotted(p) {
        margin: 0;
        margin-bottom: 2rem;
      }

      .rich-text-container::slotted(li) {
        display: flex;
        align-items: baseline;
        margin-bottom: 1rem;
        padding-left: 0.7rem;
        font-size: 0.8rem;
        line-height: 1.125;
        color: var(--color-dark-grey);
      }

      .m-content-text-specs__list-item--text {
        padding-left: 0.7rem;
        font-size: 0.8rem;
        line-height: 1.125;
        color: var(--color-dark-grey);
      }

     .m-content-text-specs__third {
          margin-top: 2rem;
        }

     .m-content-text-specs__second {
          margin-top: 2rem;
        }


      .m-content-text-specs__third--wrapper {
        height: 100%;
      }

      .m-content-text-specs__content {
         padding-bottom: 1rem;
         padding-top: 1rem;
      }

      .border-bottom {
        border-bottom: 1px solid #E5641F;
      }

      .aligned-end {
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
      }

       @media only screen and (min-width: 992px){
       .m-content-text-specs__content {
        padding-bottom: 4rem;
        padding-top: 4rem;

      }

        .m-content-text-specs__third {
          margin-top: 0;
        }

        .m-content-text-specs__second {
          margin-top: 0;
        }
       }
    `
  ];



  @property()
  title: string;

  @property({attribute: 'has-border'})
  hasBorder: boolean;

  @property({attribute: 'text-end'})
  isAlignedEnd: boolean;


  protected render(): unknown {
    return html`
          <webs-grid-row class="m-content-text-specs__content ${this.hasBorder ? 'border-bottom' : ''}">
            <webs-grid-column md="2" class="m-content-text-specs__first">
              ${this.title ? html`<h5 class="m-content-text-specs__first--title">${this.title}</h5>` : html``}
            </webs-grid-column>
            <webs-grid-column md="5" class="m-content-text-specs__second">
              <div class="rich-text-container"><slot></slot></div>
            </webs-grid-column>

            <webs-grid-column md="4" md-offset="1" class="m-content-text-specs__third">
              <div class="m-content-text-specs__third--wrapper ${this.isAlignedEnd ? 'aligned-end' : ''}">
                <slot name="right-content"></slot>
              </div>
            </webs-grid-column>
          </webs-grid-row>
            `
            }
            }
